import { combineReducers } from 'redux';

import loading from 'modules/global/reducers/generic.loading';

import isFollowUpConfigModalOpen from './isFollowUpConfigModalOpen';
import isReady from './isReady';
import * as types from '../../../actionTypes';

/**
 * @typedef {{
 *  isReady: boolean,
 *  isFollowUpConfigModalOpen: boolean,
 *  loading: {
 *    update: boolean,
 *    create: boolean,
 *    isSavingFollowUpConfig: boolean,
 *  },
 * }} StepUiDetailsReducer
 */

export default combineReducers({
  isReady,
  isFollowUpConfigModalOpen,
  loading: combineReducers({
    update: loading(types.UPDATE_STEP_REQUEST),
    create: loading(types.CREATE_STEP_REQUEST),
    isSavingFollowUpConfig: loading(types.SAVE_FOLLOW_UP_CONFIG),
  }),
});
